// Dependency
import React, {useState} from "react";
import SwiperCore, {Navigation} from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react';

// Components
import PostTags from "./post-tags/post-tags";
import StoryCard from "./cards/story-card";
import InstaStory from "./insta-stories";

// Styles
import 'swiper/scss';
import 'swiper/scss/navigation';

import * as storiesStyles from '../components/stories.module.scss';

// install Swiper modules
SwiperCore.use([Navigation]);

// Template
const Stories = (props) => {

    const [renderStories, setRenderStories] = useState(false);
    const [currentStory, setCurrentStory] = useState([]);

    const toggleStories = () => {
        setRenderStories(!renderStories);
    };

    return (
        <section className={`${storiesStyles.cdStoriesSection} ${props.cname}`}>
            <div className="cd-max-width">
                <div className="cd-heading">
                    {props.children}
                </div>
                <div className="cd-swiper-wrapper">
                    <Swiper className={`cd-story-swiper cd-swiper`}
                        spaceBetween={20}
                        slidesPerView={3}
                        slidesPerGroup={1}
                        grabCursor={true}
                        watchSlidesProgress={true}
                            navigation={ {
                                nextEl: '.cd-story-next',
                                prevEl: '.cd-story-prev'
                            }}
                        breakpoints={{
                            1100: {
                                spaceBetween: 20,
                                slidesPerView: 3,
                                slidesPerGroup: 1
                            },
                            700:{
                                spaceBetween: 8,
                                slidesPerView: 2,
                                slidesPerGroup: 1
                            },
                            0:{
                                spaceBetween: 8,
                                slidesPerView: 2,
                                slidesPerGroup: 1
                            }
                        }}
                    >
                        { props.data && props.data.map( (element, index) => {
                            return <SwiperSlide key={index.toString()}>
                                <StoryCard
                                    showStories={toggleStories}
                                    key={element.id}
                                    story={element}
                                    setStory={setCurrentStory}
                                />
                            </SwiperSlide>
                        }) }
                        <div className={` cd-swiper-arrows cd-next-arrow cd-story-next`}>
                            <div className="cd-arrow"></div>
                        </div>
                        <div className={` cd-swiper-arrows cd-prev-arrow cd-story-prev`}>
                            <div className="cd-arrow"></div>
                        </div>
                    </Swiper>
                </div>

                {
                    props && props.postTags &&  <PostTags data={props.postTags} />
                }

            </div>

            <InstaStory
                showStories={renderStories}
                closeStories={toggleStories}
                storyContent={currentStory}
            />

        </section>
    )
}

export default Stories
